import payment from "../../asset/images/payment.png";
import { useNavigate } from 'react-router-dom';

const Paymentsuccess = () => {
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Set a timeout to redirect after 5 seconds
  //   const timer = setTimeout(() => {
  //     navigate('/'); // Replace '/home' with your desired route
  //   }, 5000);

  //   // Cleanup function to clear the timer if the component is unmounted
  //   return () => clearTimeout(timer);
  // }, [navigate]);

  const handleReturnToHome = () => {
    navigate('/');
  };


  return (
    <div>
      <div className='payment-success'>
        <img 
          src={payment}
          alt="Payment successful"
        />
        <h1>Payment Success! You will get an email with login credentials shortly. </h1>

        <button onClick={handleReturnToHome} className="retry-button">
          Return to Home Page
        </button>
      </div>
    </div>
  );
}

export default Paymentsuccess;
